import { useCallback, useState } from 'react';
import { IStep, IUseModalGreenfyWhatCanYouDo } from '../types';

const useModalGreenfyWhatCanYouDo = ({
  onClose,
}: IUseModalGreenfyWhatCanYouDo) => {
  const [stepCurrent, setStepCurrent] = useState<number>(0);

  const handleStepCurrent = (value: number) => {
    setStepCurrent(value);
  };
  const steps: Array<IStep> = [
    {
      id: 0,
      title: 'Disponível',
      icon: {
        iconName: 'VerifiedOutlined',
        htmlColor: '#005F47',
      },
      options: [
        {
          id: 0,
          title: 'RESPONDER DÚVIDAS SOBRE AQUICULTURA;',
        },
        {
          id: 1,
          title: 'NAVEGAR NA PLATAFORMA;',
        },
        {
          id: 2,
          title: 'INFORMAÇÕES SOBRE VIVEIROS',
        },
        {
          id: 3,
          title: 'INFORMAÇÕES DA FAZENDA;',
        },
        {
          id: 4,
          title: 'E MUITO MAIS.',
        },
      ],
    },
    {
      id: 1,
      title: 'Em breve',
      icon: {
        iconName: 'AutoModeOutlined',
        htmlColor: '#828282',
      },
      options: [
        {
          id: 0,
          title: 'SUGESTÕES DE INSERÇAÕ DE DADOS;',
        },
        {
          id: 1,
          title: 'GERAR GRÁFICOS;',
        },
        {
          id: 2,
          title: 'RELATÓRIOS;',
        },
        {
          id: 3,
          title: 'SUGESTÕES DE GESTÃO.',
        },
        {
          id: 4,
          title: 'EM BREVE',
        },
      ],
    },
  ];

  const handelSetPrompt = useCallback((prompt: string) => {
    onClose();
  }, []);

  return { steps, stepCurrent, handelSetPrompt, handleStepCurrent };
};

export default useModalGreenfyWhatCanYouDo;
